"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntersectionObserverOpts = exports.createIntersectionObserver = void 0;

/**
 * Create a new Intersection Observer that flags the component for rendering and disconnects itself
 * once the component is visible.
 */
var createIntersectionObserver = function createIntersectionObserver(setShouldRerender, clearIntersectionObserver, intersectionObserverOpts) {
  return new IntersectionObserver(function (entries) {
    // There should only be one entry, but run through all of them just in case
    entries.forEach(function (entry) {
      // Verify element is at least partially visible before triggering a rerender
      if (entry.intersectionRatio > 0) {
        clearIntersectionObserver();
        setShouldRerender(true);
      }
    });
  }, intersectionObserverOpts);
};
/** Construct valid options for an Intersection Observer constructor */


exports.createIntersectionObserver = createIntersectionObserver;

var getIntersectionObserverOpts = function getIntersectionObserverOpts(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      root = _ref.root,
      rootCSSSelector = _ref.rootCSSSelector,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px' : _ref$rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0 : _ref$threshold;

  var opts = {
    rootMargin: rootMargin,
    threshold: threshold
  }; // Set the root if its defined explicitly otherwise get it from the DOM with the rootCSSSelector
  // if defined

  if (root) opts.root = root;else if (rootCSSSelector) opts.root = document.querySelector(rootCSSSelector);
  return opts;
};

exports.getIntersectionObserverOpts = getIntersectionObserverOpts;